angular.module('SSATB.LocalForage', ['LocalForageModule'])
.provider('ssatbHttp', ['$localForageProvider', function ($localForageProvider) {

    var _config = {
        driver: [localforageSsatbDriver.DRIVER_NAME]
    };

    this.config = function (config) {
        if (!angular.isObject(config))
            throw new Error('The config parameter should be an object');

        _config = angular.extend(_config, config);
        $localForageProvider.config(_config);
    };

    var interceptorFactories = this.interceptors = [];

    function getApiNameByUrl(url) {

        if (!angular.isObject(_config.apiInfo))
            return null;

        var service = null;
        angular.forEach(_config.apiInfo, function (value, key) {
            if (url.toLowerCase().indexOf(value.Url.toLowerCase()) === 0) {
                service = key;
            }
        });
        return service;
    }

  

    this.$get = ['$localForage', '$q', '$injector', function ($localForage, $q, $injector) {

        var reversedInterceptors = [];
        angular.forEach(interceptorFactories, function (interceptorFactory) {
            reversedInterceptors.unshift(angular.isString(interceptorFactory)
                ? $injector.get(interceptorFactory) : $injector.invoke(interceptorFactory));
        });

        function ssatbHttp(requestConfig) {

            if (!angular.isObject(requestConfig))
                throw new Error('Http request configuration must be an object.');
            if (!angular.isString(requestConfig.url))
                throw new Error('Http request configuration url must be a string.');

            var config = angular.extend({
                method: 'get'
            }, requestConfig);
           
            config.method = angular.isString(config.method) ? config.method.toUpperCase() : config.method;
           
            var service = getApiNameByUrl(requestConfig.url);
            if (service === null)
                throw new Error('No matching apiInfo was found in the provider configuration for the service URL ' + requestConfig.url);

            var requestInterceptors = [];
            var responseInterceptors = [];
            var promise = $q.when(config);

            // apply interceptors
            angular.forEach(reversedInterceptors, function (interceptor) {
                if (interceptor.request || interceptor.requestError) {
                    requestInterceptors.unshift(interceptor.request, interceptor.requestError);
                }
                if (interceptor.response || interceptor.responseError) {
                    responseInterceptors.push(interceptor.response, interceptor.responseError);
                }
            });

            promise = chainInterceptors(promise, requestInterceptors);
            promise = promise.then(function (result) {
                var apiInfo = _config.apiInfo[service];
                var key = service + '|' + config.method + '|' + requestConfig.url.substring(apiInfo.Url.length);
                if (angular.isDefined(requestConfig.ignore404)) {
                    key += '|' + requestConfig.ignore404;
                }
                if (config.method === 'GET')
                    return $localForage.getItem(key);
                else
                    if (config.method === 'DELETE')
                        return $localForage.removeItem(key);
                    else
                        return $localForage.setItem(key, requestConfig.data);

            });
            promise = promise.then(function (response) {
                if (response != null)
                    response.config = config;
                else
                    return { config: config };
                return response;

            }, function (response) {
                if (response != null) {
                    response.config = config
                    throw response
                }
                else {
                    throw new { config: config };
                }
            });

            return chainInterceptors(promise, responseInterceptors);
        }

        createShortMethods('get', 'delete');
        createShortMethodsWithData('post', 'put');

        return ssatbHttp;

        function createShortMethods(names) {
            angular.forEach(arguments, function (name) {
                ssatbHttp[name] = function (url, config) {
                    return ssatbHttp(angular.extend({}, config || {}, {
                        method: name,
                        url: url
                    }));
                };
            });
        }

        function createShortMethodsWithData(name) {
            angular.forEach(arguments, function (name) {
                ssatbHttp[name] = function (url, data, config) {
                    return ssatbHttp(angular.extend({}, config || {}, {
                        method: name,
                        url: url,
                        data: data
                    }));
                };
            });
        }
        function chainInterceptors(promise, interceptors) {
            for (var i = 0, ii = interceptors.length; i < ii;) {
                var thenFn = interceptors[i++];
                var rejectFn = interceptors[i++];
                promise = promise.then(thenFn, rejectFn);
            }
            interceptors.length = 0;
            return promise;
        }

    }];

}]);